import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { TranslateService } from '@ngx-translate/core';

import { OpenAPIService } from '../../services/openAPI.service';

@Component({
  selector: 'medical-photo-preview',
  templateUrl: './medical-photo-preview.component.html',
  styleUrls: [
    './medical-photo-preview.component.scss'
  ]
})
export class MedicalPhotoPreviewComponent implements OnInit {

  id: any = null;
  photoPlaceholder: string | null = null;

  svgDrawOptions: any = {
    shoulder: { frontal: true, back: true, left_side: true, right_side: true },
    elbow: { frontal: true, back: true, left_side: true, right_side: true },
    hip: { frontal: true, back: true, left_side: true, right_side: true },
    knee: { frontal: true, back: true, left_side: true, right_side: true },
    wrist: { frontal: true, back: true, left_side: true, right_side: true },
    ankle: { frontal: true, back: true, left_side: true, right_side: true },
    ear: { frontal: true, back: true, left_side: true, right_side: true },
    eye: { frontal: true, back: true, left_side: true, right_side: true },
    nose: { frontal: true, back: true, left_side: true, right_side: true }
  };

  _widthOrig: number = 1200;
  _heightOrig: number = 1200;
  _width: number = 420;
  _widthBox: number = 420;
  _height: number = 720;
  _heightBox: number = 720;
  _widthOffset: number = 0;
  _heightOffset: number = 15;
  _viewBox: string = `0 0 ${this._widthBox} ${this._heightBox}`;
  _r: number = 4;
  _fillColor: string = '#ff0000';
  _lineColorLeft: string = '#00ffff';
  _lineColorRight: string = '#ff00ff';
  _lineColor: string = '#ffff00';
  _axisColor: string = '#FFA50080';

  _imageDimensions: any = null;

  photo: any = null;

  spin: boolean = false;

  imageUrl: string | null = null;

  showGrid: boolean = false;

  constructor(
    private modalController: ModalController,
    private translate: TranslateService,
    private apiService: OpenAPIService
  ) { }

  ngOnInit() {
    this._loadMedicalPhoto(this.id);
  }

  dismiss(data?: any) {
    this.modalController.dismiss(data);
  }

  _loadMedicalPhoto(id: number) {
    this.spin = true;
    this.apiService.getDetails('medicalphotos', id).subscribe({
      next: (response: any) => {
        this.photo = { ...response.data };
        const _mimeType = this.photo.mime_type || 'image/jpeg';
        this.imageUrl = `data:${_mimeType};base64,${this.photo.image}`;
        this._setDimensions(this.imageUrl);
        this.spin = false;
      },
      error: (error: any) => {
        console.log('_loadMedicalPhoto error', error);
        this.spin = false;
      }
    });
  }

  _setDimensions(image: string) {
    let width: number | null = null;
    let height: number | null = null;

    var img = new Image();
    img.src = image;

    img.onload = () => {
      width = img.width;
      height = img.height;
      this._imageDimensions = { width, height };

      const _diff = (height - width);
      // width += _diff;

      const _scale = 0.6;

      this._widthOrig = width + ( width * 65 / 100);
      this._heightOrig = height;
      this._width = width * _scale;
      this._widthBox = width * _scale;
      this._height = height * _scale;
      this._heightBox = height * _scale;
      this._widthOffset = 0;
      this._heightOffset = 0;
      this._viewBox = `0 0 ${this._width} ${this._height}`;
      // console.log('_getDimensions', this._imageDimensions);
      // console.log('_viewBox', this._viewBox);
    }
  }

  toggleGrid() {
    this.showGrid = !this.showGrid;
  }
}
